import marked from 'marked';
import sanitizeHTML from 'sanitize-html';

// options for sanitizing HTML
export const sanitize = input =>
  sanitizeHTML(input, {
    allowedTags: sanitizeHTML.defaults.allowedTags.concat(['sup', 'img']),
    allowedAttributes: {
      img: ['src', 'alt'],
      a: ['href', 'target', 'rel']
    }
  });

// customize the renderer for marked so we can make hyperlinks open new browser tabs/windows
const renderer = new marked.Renderer();

// eslint-disable-next-line
renderer.link = function(href, title, text) {
  if (this.options.sanitize) {
    let prot;
    try {
      prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return '';
    }
    if (
      // eslint-disable-next-line
      prot.indexOf('javascript:') === 0 ||
      prot.indexOf('vbscript:') === 0 ||
      prot.indexOf('data:') === 0
    ) {
      return '';
    }
  }

  // eslint-disable-next-line
  let out = '<a target="_blank" rel="noopener noreferrer" href="' + href + '"';

  if (title) {
    // eslint-disable-next-line
    out += ' title="' + title + '"';
  }

  // eslint-disable-next-line
  out += '>' + text + '</a>';

  return out;
};

// settings for markdown parser
marked.setOptions({
  renderer,
  gfm: false,
  sanitize: false,
  pedantic: false,
  smartLists: false,
  smartypants: true,
});

export { marked };



// WEBPACK FOOTER //
// ./src/common/utils.js